import { z } from 'zod';

import { moduleSchema } from '@/schemas/commons';
import type { ZodUseQuery } from '@/utils/zodReactQuery';

export const modulesResponse = z.array(moduleSchema);
export type ModulesResponse = z.infer<typeof modulesResponse>;
export type UseModules = ZodUseQuery<ModulesResponse>;
